module.exports = __webpack_public_path__ + "static/media/avatar-empty.77f5794e.png";